export class ConsultationDischargeWriteDisabledError extends Error {
  constructor() {
    super('The consultation discharge write is disabled on this backend.');
    this.name = 'ConsultationDischargeWriteDisabledError';
  }
}
